import { getProductSession } from "./getProductSession";
import { priceFormatter } from "./priceFormatter";

export const getInstallment = ({
  payment,
  paramType,
  entityId,
  final_price_int,
}: any) => {
  const couponEntityType = payment?.coupon_entity_type;
  const couponEntityId = Number(payment?.coupon_entity_id);
  const couponProductPriceDiscount = Number(
    payment?.coupon_product_price_discount,
  );

  const showDiscountWithCoupon =
    couponEntityType === paramType && couponEntityId === entityId;

  const installmentObject = {
    installment: 1,
    value: showDiscountWithCoupon
      ? couponProductPriceDiscount
      : final_price_int,
    amount: showDiscountWithCoupon
      ? couponProductPriceDiscount
      : final_price_int,
    assumed_fee: 0,
    fee: 0,
    free_installment: true,
  };

  sessionStorage.setItem("installment", JSON.stringify(installmentObject));
  return installmentObject;
};

export const getInstallments = () => {
  const productSession = getProductSession();

  const installmentObject = {
    installment: 1,
    value: productSession.final_price_int,
    amount: productSession.final_price_int.toString(),
    assumed_fee: 0,
    fee: 0,
    free_installment: true,
  };

  const installments = [installmentObject, ...productSession.installments];

  return installments;
};

export const getInstallmentsCheckoutOnePage = (installments) => {
  const formattedInstallments = installments.map((installment) => {
    if (installment.free_installment) {
      return {
        value: installment.installment,
        label: `${installment.installment}x de R$ ${priceFormatter(
          installment.value,
        )} sem juros`,
      };
    } else {
      return {
        value: installment.installment,
        label: `${installment.installment}x de R$ ${priceFormatter(
          installment.value,
        )}*`,
      };
    }
  });

  return [...formattedInstallments];
};
